import moment from 'moment';
import {
  AtendimentosProps,
  FormattedApexChart,
  PorteUsers,
  TipoPessoaUsers,
} from '../dashboard.interfaces';
import {
  LineChartCategories,
  LineChartSeries,
} from '../../../components/Charts/Line/LineChartInterfaces';

export function formattedPerfilUsuarioUser(
  data: TipoPessoaUsers
): FormattedApexChart {
  if (!data) {
    return {
      series: [],
      categories: { categories: [] },
      total: 0,
    };
  }

  const series: LineChartSeries[] = [
    {
      name: 'Todas',
      data: data.dataTodas.atendimentos.map(
        (perfil: AtendimentosProps) => perfil.total
      ),
    },
    {
      name: 'Pessoa Física',
      data: data.dataPf.atendimentos.map(
        (perfil: AtendimentosProps) => perfil.total
      ),
    },
    {
      name: 'Pessoa Jurídica',
      data: data.dataPj.atendimentos.map(
        (perfil: AtendimentosProps) => perfil.total
      ),
    },
  ];

  const categories: LineChartCategories = {
    categories: data.dataTodas.atendimentos.map((item: AtendimentosProps) =>
      moment(item.data).format('DD MMM')
    ),
  };

  const total = data.dataTodas.total;

  return {
    series,
    categories,
    total,
  };
}
export function formattedPorteUser(data: PorteUsers): FormattedApexChart {
  if (!data) {
    return {
      series: [],
      categories: { categories: [] },
      total: 0,
    };
  }

  const series: LineChartSeries[] = [
    {
      name: 'MEI',
      data: data.dataMei.atendimentos.map((p: AtendimentosProps) => p.total),
    },
    {
      name: 'ME',
      data: data.dataMe.atendimentos.map((p: AtendimentosProps) => p.total),
    },
    {
      name: 'EPP',
      data: data.dataEpp.atendimentos.map((p: AtendimentosProps) => p.total),
    },
    {
      name: 'OUTROS',
      data: data.dataOutros.atendimentos.map((p: AtendimentosProps) => p.total),
    },
  ];

  const categories: LineChartCategories = {
    categories: data.dataOutros.atendimentos.map((item: AtendimentosProps) =>
      moment(item.data).format('DD MMM')
    ),
  };

  function somarTotais(objeto: any) {
    let soma = 0;
    for (const key in objeto) {
      if (objeto[key].total) {
        soma += objeto[key].total;
      }
    }
    return soma;
  }

  const total = somarTotais(data);

  return {
    series,
    categories,
    total,
  };
}
